module.exports = __webpack_public_path__ + "static/personaggi_header_1-bd3ff1e807feb99bdb89c0d5b599910f.png";